import React from 'react';

import { useAppSelector, useAuthentication, useNewOrder } from '@pkg/hooks';
import { type MarketplaceCollectible } from '@pkg/types';

import { type CollectionChainType } from '@app/client';
import { useCancelOrder } from '@app/pages/ProfilePage/hooks';
import { useOrdersStore } from '@app/store/zustand';

import { NftManagerOptionsMenu } from './OptionsMenu';

import { ListButton, Wrapper } from './styles';

interface Props {
    nftItem: MarketplaceCollectible;
    chain?: CollectionChainType;
    isListed?: boolean;
}

export const NFTManagerControls = ({ nftItem, isListed, chain }: Props) => {
    const isLoadingOrderRequest = useOrdersStore.getState().orderRequestPendingId === nftItem.id;
    const { protectedAction } = useAuthentication();
    const marketplaceV1Enabled = useAppSelector((state) => state.featureFlags.features.marketplaceV1Enabled);

    const { mutate: cancelListing, isPending: isPendingCancelOrder } = useCancelOrder();

    const isLoading = isPendingCancelOrder || isLoadingOrderRequest;
    const { list } = useNewOrder();
    function listItem() {
        protectedAction(() => list([nftItem]));
    }

    const latestOrderId = nftItem?.orders?.[0]?.id; // will probably be changed or orderItemId
    function handleCancel() {
        if (latestOrderId) {
            protectedAction(() => cancelListing({ orderItemId: latestOrderId }));
        }
    }
    const canRenderCancel = isListed && latestOrderId?.startsWith('yat.');
    const listingMarkup =
        isListed && canRenderCancel ? (
            // TODO: this will be the reservoir id so it wont work until BE adds orderItemId to Cancel Listing
            <ListButton $isCancel onClick={() => handleCancel()}>
                {isLoading ? 'Loading...' : 'Cancel Listing'}
            </ListButton>
        ) : (
            <ListButton onClick={listItem}>{isLoading ? 'Loading...' : 'List now'}</ListButton>
        );

    const hasListingMarkup = marketplaceV1Enabled && (isListed || !canRenderCancel);

    return (
        <Wrapper $hasListingMarkup={hasListingMarkup}>
            {marketplaceV1Enabled && listingMarkup}
            <NftManagerOptionsMenu chain={chain} item={nftItem} />
        </Wrapper>
    );
};
